import { render, staticRenderFns } from "./ProjectStatus.vue?vue&type=template&id=fcc9eab2&scoped=true"
import script from "./ProjectStatus.vue?vue&type=script&lang=js"
export * from "./ProjectStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcc9eab2",
  null
  
)

export default component.exports